import {useSearchOptions} from "../../../hooks/useSearchOptions";
import {groupListURL} from "./groupTable.constants";

export const useGroupsSearchOptions = () => {
  const options = useSearchOptions(groupListURL, ["name"]);

  const searchOptions = [
    {
      category: {label: "Name", value: "name"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.name,
    },
  ];

  return {searchOptions};
};
